<template>
  <div>
    <hr />
    <b-container>
      <b-row>
        <b-col class="px-0" cols="2">
          <SHIcons v-if="!reaction.icon" name="parson" width="32" height="32"/>
          <b-img v-else :src="reaction.icon" class="mr-1 border" width="32" height="32" rounded="circle" style="object-fit: cover" alt="Circle image"></b-img>
        </b-col>
        <b-col class="px-0" cols="6">
          <b-link class="name" v-if="reaction.url_string && reaction.is_deleted === '0'" @click="handleClickProfile">{{name}}</b-link>
          <span class="name" v-else>{{name}}</span>
        </b-col>
        <b-col class="date px-0" cols="4">{{date}}</b-col>
      </b-row>
      <b-row class="comment pr-0">
        <b-col class="px-0" cols="2"></b-col>
        <b-col cols="10" class="px-0">{{reaction.comment}}</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import SHIcons from '@/components/ico/SHIcons'
import dayjs from 'dayjs'
export default {
  name: 'AnnouncementDetailComment',
  components: {
    SHIcons
  },
  props: {
    reaction: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    name() {
      if (this.reaction.is_deleted === '1') {
        return '削除されたユーザ'
      }
      return this.reaction.name
    },
    date() {
      return dayjs(this.reaction.updated_at).format('YY年M月D日\n HH:mm')
    }
  },

  methods: {
    handleClickProfile: function () {
      this.$emit('click-profile', this.reaction.url_string)
    }
  }
}
</script>

<style scoped>
.date {
  font-size: 12px;
  vertical-align: bottom;
  text-align: right;
}
.name {
  font-size: 14px;
}
</style>
